import { render, staticRenderFns } from "./tuiDetails.vue?vue&type=template&id=7fb0425a&scoped=true"
import script from "./tuiDetails.vue?vue&type=script&lang=js"
export * from "./tuiDetails.vue?vue&type=script&lang=js"
import style0 from "./tuiDetails.vue?vue&type=style&index=0&id=7fb0425a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb0425a",
  null
  
)

export default component.exports